import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as consentApi from '@/api/consent';
import type { RecordConsentPayload, GenerateLinkPayload } from '@/api/consent';

const CONSENTS_KEY = ['consents'] as const;

export function useMemberConsents(memberId: string | undefined) {
  return useQuery({
    queryKey: [...CONSENTS_KEY, memberId],
    queryFn: () => consentApi.getMemberConsents(memberId!),
    enabled: !!memberId,
    staleTime: 2 * 60 * 1000,
  });
}

export function useRecordConsent(memberId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: RecordConsentPayload) =>
      consentApi.recordConsent(memberId, payload),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [...CONSENTS_KEY, memberId] });
    },
  });
}

export function useWithdrawConsent(memberId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (consentId: number) => consentApi.withdrawConsent(consentId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [...CONSENTS_KEY, memberId] });
    },
  });
}

export function useGenerateConsentLink(memberId: string) {
  return useMutation({
    mutationFn: (payload: GenerateLinkPayload) =>
      consentApi.generateConsentLink(memberId, payload),
  });
}
